import Styled from 'styled-components';

import CloseButtonGray from '../../images/components/close-modal-gray.svg';
import CloseButtonPurple from '../../images/components/close-modal-purple.svg';
import CelebratingMan from '../../images/v2/avatars/CelebratingMan.svg';

export const NpsWrapper = Styled.div`
    z-index: 9999;
	position: absolute;
	bottom: 94px;
    right: 16px;
    overflow-y: hidden;
    
    border-radius: 4px;
    box-shadow: 0 1px 8px 2px rgba(0, 0, 0, 0.08);
    border: solid 1px #dbdbdb;
    background-color: #ffffff;

    padding: ${props => (props.extraPadded ? '40px' : '30px 40px')};

    &.nps-enter {
        opacity: 0.01;
    }

    &.nps-enter.nps-enter-active {
        opacity: 1;
        transition: opacity .5s ease-in;
    }

    &.nps-leave {
        opacity: 1;
    }

    &.nps-leave.nps-leave-active {
        opacity: 0.01;
        transition: opacity 300ms ease-in;
    }
`;

export const NpsTitle = Styled.div`
    width: 342px;
    font-size: ${props => props.fontSize || '14px'};
    font-weight: 500;
    margin-bottom: 16px;
    text-align: ${props => (props.centerText ? 'center' : 'left')};
`;

export const NpsContent = Styled.div`
    display: flex;
    justify-content: center;
`;

export const FlexCol = Styled.div`
    flex-direction: column;
    flex-grow: 1;
`;

export const EmojiContainer = Styled.div`
    display: flex;
    justify-content: center;
    min-height: 35px;
`;

export const Emoji = Styled.div`
    cursor: pointer;
    background-image: url(${props => props.imageSrc});
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 8px;
    width: 35px;
    height: 35px;
    background-size: 28px;
    &:hover {
        background-size: 35px;
    }
`;

export const NumberContainer = Styled.div`
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    margin-bottom: 10px;
`;

export const NumberField = Styled.div`
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    background-color: #f5f5f8;
    cursor: pointer;
    &:hover {
        color: #ffffff;
        background-color: #6e0fea;
    }
`;

export const NpsFooter = Styled.div`
    display: flex;
    justify-content: space-between;
`;

export const NpsFooterText = Styled.div`
    font-size: 11px;
    font-weight: 500;
    color: #a1a1a1;
`;

export const CloseButton = Styled.div`
    border: none;
    width: 12px;
    height: 12px;
    background-size: 12px;
    background-image: url(${CloseButtonGray});
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 16px;
    &:hover {
        background-image: url(${CloseButtonPurple});
    }
`;

export const ButtonWrapper = Styled.div`
    display: flex;
    justify-content: flex-end; 
    margin-top: 16px;
`;

export const CelebratingGuy = Styled.div`
    width: 70px;
    height: 104px;
    background-size: 70px;
    margin: 0 auto 10px auto;
    background-image: url(${CelebratingMan});
`;

export const ReviewButtonWrapper = Styled.div`
    display: flex;
    justify-content: center;
`;
